import { z } from "zod";

export const MedVisitCitationSchema = z
  .object({
    file_id: z.string(),
    start_page: z.number().int().min(1),
    end_page: z.number().int().min(1),
  })
  .refine((citation) => citation.start_page <= citation.end_page, {
    message: "start_page must not be after end_page",
  });

export type MedVisitCitation = z.infer<typeof MedVisitCitationSchema>;

export interface MedVisitCreateDetail {
  visit_detail_category: string;
  visit_details: string;
}

export interface MedVisitCreateRequest {
  visit_date: string | null;
  visit_type_id: string;
  provider_name: string | null;
  facility_name: string | null;
  visit_subtype?: string | null;
  citations?: MedVisitCitation[];
  details?: MedVisitCreateDetail[];
}

/** Full PUT body; omitting citations leaves the citation list alone. */
export interface MedVisitUpdateRequest {
  visit_date: string | null;
  visit_type_id: string;
  provider_name: string | null;
  facility_name: string | null;
  visit_subtype: string | null;
  citations?: MedVisitCitation[];
}

export interface MedVisitCreateResponse {
  visit_id: string;
}
